import angular from 'angular';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import { TemplatesCreateSchedulesCreateTimesControllerModule } from './controllers/TemplatesCreateSchedulesCreateTimesController';  

export const TemplatesCreateSchedulesCreateTimesView = angular
  .module('acme.view.application.templates.create.schedules.create.times', [
    uiRouter,
    'ui.bootstrap',
    TemplatesCreateSchedulesCreateTimesControllerModule,
  ])

  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.templates.create.schedules.create.times',
      url: '/times',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateSchedulesCreateTimesController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/schedules/create/times/times.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Event Template Schedule Times',
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.schedules.create.times',
      url: '/times/:type',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateSchedulesCreateTimesController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/schedules/create/times/times.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Event Template Schedule Times',
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.schedules.edit.times',
      url: '/times',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateSchedulesCreateTimesController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/schedules/create/times/times.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Event Template Schedule Times',
      },
    });
  }).name;
